import { findLast } from '@/utils';
import { RecommendationStoreAdapter } from './storeAdapter';
import { RecommendationItem, RecommendationStoreState } from './types';
import { defaultState } from './utils';

export class RecommendationStore {
    private adapter: RecommendationStoreAdapter;
    private currentRecommendationId: string | null = null;

    state: RecommendationStoreState = defaultState;

    constructor(storeAdapter: RecommendationStoreAdapter) {
        this.adapter = storeAdapter;
        this.state = this.adapter.getAll();
    }

    addItem(item: RecommendationItem) {
        this.state.items.push(item);
        this.save();
    }

    setRecommendationId(id: string): void {
        this.currentRecommendationId = id;
    }

    getRecommendationId(): string | null {
        return this.currentRecommendationId;
    }

    /**
     * Finds the ID of the source recommendation based on item ID.
     *
     * @param itemId - The ID of the current item.
     * @returns The ID of the source recommendation.
     */
    findSourceRecommendationId(itemId: string): string | null {
        const item = findLast(this.state.items, (item) => item.id === itemId);

        if (!item) {
            return null;
        }

        return item.recommendedBy;
    }

    private save() {
        this.adapter.save(this.state);
    }
}
